import { render, staticRenderFns } from "./StructureHome.vue?vue&type=template&id=4b707220&"
import script from "./StructureHome.vue?vue&type=script&lang=js&"
export * from "./StructureHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports